import {
  Box,
  Container,
  Theme,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import classnames from 'classnames'
import FreeGiftModal from 'baby-ui/compounds/FreeGiftModal/FreeGiftModal'
import React from 'react'
import Alert from '@material-ui/lab/Alert'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import FreeGiftHeroSection from 'baby-ui/compounds/FreeGiftHeroSection/FreeGiftHeroSection'
import InsurancePickerWidget from '../InsurancePickerWidget'
import StarburstBadge from '../../../baby-ui/compounds/StarburstBadge'
import useStyles from './styles'
import { HeroCopy, HeroImage } from '../../components'
import { useLayout } from '../Layout'
import { HERO_IMAGE_URL } from 'bl-health/views/constants'

const heroCopy = {
  title: ['Order your pump', 'through insurance!'],
  subtitle: [
    "We'll take care of contacting your provider",
    'and billing your insurance.',
  ],
}

export default function HeroBannerWidget() {
  const classes = useStyles()
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'))
  const layout = useLayout()
  const [isFreeGiftModalOpen, setIsFreeGiftModalOpen] = React.useState(false)
  const [isToastOpen, setIsToastOpen] = React.useState(false)

  // close toast after 10 seconds
  React.useEffect(() => {
    if (isToastOpen) {
      setTimeout(() => {
        setIsToastOpen(false)
      }, 10000)
    }
  }, [isToastOpen])

  return (
    <>
      {isToastOpen && (
        <div className={classes.toastWrapper}>
          <Alert
            className={classes.toastContent}
            icon={<InfoOutlinedIcon color="primary" />}
            severity="info"
          >
            To get your free gift, first select your shipping state and
            insurance carrier.
          </Alert>
        </div>
      )}

      <FreeGiftModal
        open={isFreeGiftModalOpen}
        onClose={() => {
          setIsFreeGiftModalOpen(false)
        }}
      />

      <div
        className={classnames({
          [classes.contrastBgColor]: layout?.isFreeGiftEnabled,
        })}
      >
        <HeroImage heroImageUrl={HERO_IMAGE_URL}>
          {isDesktop ? (
            <Container className={classes.heroContainer}>
              <Box
                className={classes.overlay}
                color="primary.contrastText"
                p={6}
                pl={8}
                pt={9}
              >
                <svg
                  className={classes.curvedText}
                  viewBox="0 0 120 120"
                  width="90"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 35 150 a 60 -60 0 0 1 100 -100"
                    fill="none"
                    id="curve"
                  />
                  <text>
                    <textPath
                      fill="white"
                      fontSize="18"
                      fontWeight="bold"
                      href="#curve"
                      startOffset="54"
                      textLength="146"
                    >
                      SUPER PUMPED
                    </textPath>
                  </text>
                </svg>

                <Box pr={4}>
                  <HeroCopy {...heroCopy} />
                </Box>
                <Box py={3}>
                  <InsurancePickerWidget />
                </Box>
              </Box>
            </Container>
          ) : null}
        </HeroImage>

        <Container className={classes.starburstContainer}>
          <StarburstBadge
            className={classes.starburst}
            label={
              <Box color="primary.contrastText">
                <Typography
                  style={{ lineHeight: 1.1, fontSize: 24, fontWeight: 'bold' }}
                  variant="body1"
                >
                  YOU
                  <br />
                  GOT
                  <br />
                  THIS!
                </Typography>
              </Box>
            }
          />
        </Container>

        {!isDesktop && (
          <Container className={classes.mobileFormContainer}>
            <Box pt={4}>
              <HeroCopy {...heroCopy} />
            </Box>
            <Box pt={3}>
              <InsurancePickerWidget />
            </Box>
          </Container>
        )}

        {layout?.isFreeGiftEnabled && (
          <FreeGiftHeroSection
            onButtonClick={() => setIsToastOpen(true)}
            onLinkClick={() => setIsFreeGiftModalOpen(true)}
          />
        )}
      </div>
    </>
  )
}
